module.exports = __webpack_public_path__ + "img/word1.729ffe67.png";